export const FINANCIAL_ROUTES = [
  {
    path: '/expenses',
    name: 'ExpenseList',
    component: () => import('./expenses/views/ExpenseList.vue'),
  },
  {
    path: '/expenses/create',
    name: 'CreateExpense',
    component: () => import('./expenses/views/CreateExpense.vue'),
  },
  {
    path: '/expenses/:id/edit',
    name: 'EditExpense',
    component: () => import('./expenses/views/EditExpense.vue'),
  },
  {
    path: '/payments',
    name: 'PaymentList',
    component: () => import('./payments/views/PaymentList.vue'),
  },
  {
    path: '/payments/create',
    name: 'CreatePayment',
    component: () => import('./payments/views/CreatePayment.vue'),
  },
  {
    path: '/payments/:id/edit',
    name: 'EditPayment',
    component: () => import('./payments/views/EditPayment.vue'),
  },
  {
    path: '/invoices',
    name: 'InvoiceList',
    component: () => import('./invoices/views/InvoiceList.vue'),
  },
  {
    path: '/invoices/unpaid',
    name: 'UnpaidInvoices',
    component: () => import('./invoices/views/UnpaidInvoices.vue'),
  },
  {
    path: '/invoices/create',
    name: 'CreateInvoice',
    component: () => import('./invoices/views/CreateInvoice.vue'),
  },
  {
    path: '/invoices/view',
    name: 'ViewInvoices',
    component: () => import('./invoices/views/ViewInvoices.vue'),
  },
]
